// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/icons/icomoon.eot?e6in32", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/icons/icomoon.ttf?e6in32", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/icons/icomoon.woff?e6in32", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/icons/icomoon.svg?e6in32", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Override MUI CssBaseline's *::before rule which resets font-family to Nunito */
[class^="icon-"]::before,
[class*=" icon-"]::before {
  font-family: 'icomoon' !important;
}

.icon-close:before {
  content: "\\e90d";
}
.icon-check_circle_outline:before {
  content: "\\e910";
}
.icon-close_circle_outline:before {
  content: "\\e924";
}
.icon-Edit:before {
  content: "\\e925";
}
.icon-Send:before {
  content: "\\e926";
}
.icon-documents:before {
  content: "\\e927";
}
.icon-expand_more:before {
  content: "\\e90a";
}
.icon-search:before {
  content: "\\e90b";
}
.icon-Research:before {
  content: "\\e90c";
}
.icon-bell:before {
  content: "\\e90e";
}
.icon-question:before {
  content: "\\e90f";
}
.icon-Building:before {
  content: "\\e911";
}
.icon-List:before {
  content: "\\e912";
}
.icon-Card:before {
  content: "\\e913";
}
.icon-more_vert:before {
  content: "\\e914";
}
.icon-Expand:before {
  content: "\\e915";
}
.icon-person:before {
  content: "\\e916";
}
.icon-account:before {
  content: "\\e917";
}
.icon-Warning:before {
  content: "\\e918";
}
.icon-call:before {
  content: "\\e919";
}
.icon-location:before {
  content: "\\e91a";
}
.icon-attach_money:before {
  content: "\\e91b";
}
.icon-Tractor:before {
  content: "\\e91c";
}
.icon-Dashboard:before {
  content: "\\e91d";
}
.icon-chat-bubble:before {
  content: "\\e91e";
}
.icon-doller:before {
  content: "\\e91f";
}
.icon-circle_info:before {
  content: "\\e920";
}
.icon-Circle_Check:before {
  content: "\\e921";
}
.icon-Date:before {
  content: "\\e922";
}
.icon-first_page:before {
  content: "\\e923";
}
.icon-Filters:before {
  content: "\\e900";
}
.icon-dollar:before {
  content: "\\e901";
}
.icon-approve-file:before {
  content: "\\e902";
}
.icon-clock:before {
  content: "\\e903";
}
.icon-users:before {
  content: "\\e904";
}
.icon-shield-check:before {
  content: "\\e905";
}
.icon-campaign:before {
  content: "\\e906";
}
.icon-Management:before {
  content: "\\e907";
}
.icon-Aux-Logo:before {
  content: "\\e908";
}
.icon-file:before {
  content: "\\e909";
}
.icon-landscape-document:before {
  content: "\\e928";
}
.icon-credit-card:before {
  content: "\\e929";
}
.icon-color-palette:before {
  content: "\\e92a";
}
.icon-profile:before {
  content: "\\e92b";
}
.icon-down-arrow:before {
  content: "\\e92c";
}
.icon-up-arrow:before {
  content: "\\e92d";
}
.icon-Reload:before {
  content: "\\e92e";
}
.icon-arrow_drop_down:before {
  content: "\\e92f";
}
.icon-left-arrow:before {
  content: "\\e930";
}
.icon-office:before {
  content: "\\e931";
}
.icon-office-bag:before {
  content: "\\e932";
}
.icon-circle-dollar:before {
  content: "\\e933";
}
.icon-import_export:before {
  content: "\\e934";
}

/* Toast Notifications - Ensure errors display prominently in red */
.Toastify__toast--error {
  background-color: #f8d7da !important;
  border: 2px solid #f5222d !important;
  color: #721c24 !important;
}

.Toastify__toast--error .Toastify__toast-icon {
  color: #f5222d !important;
}

.Toastify__toast--warning {
  background-color: #fff3cd !important;
  border: 2px solid #ffc107 !important;
  color: #856404 !important;
}

.Toastify__toast--warning .Toastify__toast-icon {
  color: #ffc107 !important;
}

.Toastify__toast--info {
  background-color: #d1ecf1 !important;
  border: 2px solid #0c5460 !important;
  color: #0c5460 !important;
}

.Toastify__toast--info .Toastify__toast-icon {
  color: #0c5460 !important;
}

.Toastify__toast--success {
  background-color: #d4edda !important;
  border: 2px solid #28a745 !important;
  color: #155724 !important;
}

.Toastify__toast--success .Toastify__toast-icon {
  color: #28a745 !important;
}`, "",{"version":3,"sources":["webpack://./src/Themes/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAA8C;EAC9C;;;yDAGiE;EACjE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,+EAA+E;EAC/E,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,iFAAiF;AACjF;;EAEE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src: url('../assets/icons/icomoon.eot?e6in32');\n  src: url('../assets/icons/icomoon.eot?e6in32#iefix') format('embedded-opentype'),\n    url('../assets/icons/icomoon.ttf?e6in32') format('truetype'),\n    url('../assets/icons/icomoon.woff?e6in32') format('woff'),\n    url('../assets/icons/icomoon.svg?e6in32#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Override MUI CssBaseline's *::before rule which resets font-family to Nunito */\n[class^=\"icon-\"]::before,\n[class*=\" icon-\"]::before {\n  font-family: 'icomoon' !important;\n}\n\n.icon-close:before {\n  content: \"\\e90d\";\n}\n.icon-check_circle_outline:before {\n  content: \"\\e910\";\n}\n.icon-close_circle_outline:before {\n  content: \"\\e924\";\n}\n.icon-Edit:before {\n  content: \"\\e925\";\n}\n.icon-Send:before {\n  content: \"\\e926\";\n}\n.icon-documents:before {\n  content: \"\\e927\";\n}\n.icon-expand_more:before {\n  content: \"\\e90a\";\n}\n.icon-search:before {\n  content: \"\\e90b\";\n}\n.icon-Research:before {\n  content: \"\\e90c\";\n}\n.icon-bell:before {\n  content: \"\\e90e\";\n}\n.icon-question:before {\n  content: \"\\e90f\";\n}\n.icon-Building:before {\n  content: \"\\e911\";\n}\n.icon-List:before {\n  content: \"\\e912\";\n}\n.icon-Card:before {\n  content: \"\\e913\";\n}\n.icon-more_vert:before {\n  content: \"\\e914\";\n}\n.icon-Expand:before {\n  content: \"\\e915\";\n}\n.icon-person:before {\n  content: \"\\e916\";\n}\n.icon-account:before {\n  content: \"\\e917\";\n}\n.icon-Warning:before {\n  content: \"\\e918\";\n}\n.icon-call:before {\n  content: \"\\e919\";\n}\n.icon-location:before {\n  content: \"\\e91a\";\n}\n.icon-attach_money:before {\n  content: \"\\e91b\";\n}\n.icon-Tractor:before {\n  content: \"\\e91c\";\n}\n.icon-Dashboard:before {\n  content: \"\\e91d\";\n}\n.icon-chat-bubble:before {\n  content: \"\\e91e\";\n}\n.icon-doller:before {\n  content: \"\\e91f\";\n}\n.icon-circle_info:before {\n  content: \"\\e920\";\n}\n.icon-Circle_Check:before {\n  content: \"\\e921\";\n}\n.icon-Date:before {\n  content: \"\\e922\";\n}\n.icon-first_page:before {\n  content: \"\\e923\";\n}\n.icon-Filters:before {\n  content: \"\\e900\";\n}\n.icon-dollar:before {\n  content: \"\\e901\";\n}\n.icon-approve-file:before {\n  content: \"\\e902\";\n}\n.icon-clock:before {\n  content: \"\\e903\";\n}\n.icon-users:before {\n  content: \"\\e904\";\n}\n.icon-shield-check:before {\n  content: \"\\e905\";\n}\n.icon-campaign:before {\n  content: \"\\e906\";\n}\n.icon-Management:before {\n  content: \"\\e907\";\n}\n.icon-Aux-Logo:before {\n  content: \"\\e908\";\n}\n.icon-file:before {\n  content: \"\\e909\";\n}\n.icon-landscape-document:before {\n  content: \"\\e928\";\n}\n.icon-credit-card:before {\n  content: \"\\e929\";\n}\n.icon-color-palette:before {\n  content: \"\\e92a\";\n}\n.icon-profile:before {\n  content: \"\\e92b\";\n}\n.icon-down-arrow:before {\n  content: \"\\e92c\";\n}\n.icon-up-arrow:before {\n  content: \"\\e92d\";\n}\n.icon-Reload:before {\n  content: \"\\e92e\";\n}\n.icon-arrow_drop_down:before {\n  content: \"\\e92f\";\n}\n.icon-left-arrow:before {\n  content: \"\\e930\";\n}\n.icon-office:before {\n  content: \"\\e931\";\n}\n.icon-office-bag:before {\n  content: \"\\e932\";\n}\n.icon-circle-dollar:before {\n  content: \"\\e933\";\n}\n.icon-import_export:before {\n  content: \"\\e934\";\n}\n\n/* Toast Notifications - Ensure errors display prominently in red */\n.Toastify__toast--error {\n  background-color: #f8d7da !important;\n  border: 2px solid #f5222d !important;\n  color: #721c24 !important;\n}\n\n.Toastify__toast--error .Toastify__toast-icon {\n  color: #f5222d !important;\n}\n\n.Toastify__toast--warning {\n  background-color: #fff3cd !important;\n  border: 2px solid #ffc107 !important;\n  color: #856404 !important;\n}\n\n.Toastify__toast--warning .Toastify__toast-icon {\n  color: #ffc107 !important;\n}\n\n.Toastify__toast--info {\n  background-color: #d1ecf1 !important;\n  border: 2px solid #0c5460 !important;\n  color: #0c5460 !important;\n}\n\n.Toastify__toast--info .Toastify__toast-icon {\n  color: #0c5460 !important;\n}\n\n.Toastify__toast--success {\n  background-color: #d4edda !important;\n  border: 2px solid #28a745 !important;\n  color: #155724 !important;\n}\n\n.Toastify__toast--success .Toastify__toast-icon {\n  color: #28a745 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
